import {
	GET_FAV_TEAM,
	GET_FAV_TEAM_PROGRAMS_START,
	GET_FAV_TEAM_PROGRAMS,
	RESET_FAV_TEAM, HANDLE_FAV_TEAM_ERROR,
} from '../constants';

const initState = {
	teamIds: null,
	programs: null,
};
const favteam = (state = initState, action) => {
	switch (action.type) {
		case RESET_FAV_TEAM:
			return initState;
		case GET_FAV_TEAM:
			return {...state, teamIds: [...action.teamIds]};
		case GET_FAV_TEAM_PROGRAMS_START:
			return {
				...state,
				[action.pageNumber]: {
					...state[action.pageNumber],
					data: null,
					isLoading: true,
				},
			};
		case GET_FAV_TEAM_PROGRAMS:
			return {
				...state,
				programs: action.pageNumber === 1 ? [...action.programs] : state.programs,
				[action.pageNumber]: {
					...state[action.pageNumber],
					data: action.programs,
					isLoading: false,
					pageSize: action.paging.pageSize,
					totalPages: action.paging.totalPages,
					totalCount: action.paging.totalCount,
					hasNextPage: action.paging.hasNextPage,
				},
			};
		case HANDLE_FAV_TEAM_ERROR:
			return {
				...state,
				programs: {
					errorCode: action.errorCode,
				},
			};
		default:
			return state;
	}
};

export default favteam;
